import * as React from "react";
import { InputLabel, MenuItem, Select } from "@mui/material";
const ITEM_HEIGHT = 35;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};
const Pulldown = ({
  label,
  items = [],
  value,
  setValue,
  disabled = false,
  size = "medium",
  withLabel = true,
  withMenuProps = true,
  withEmptyMenu = false,
  additionalWork,
  valueProps = false,
}) => {
  const handleChange = (event) => {
    setValue(event.target.value);
    additionalWork && additionalWork(event.target.value, value);
  };
  return (
    <>
      {withLabel && (
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      )}

      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        size={size}
        value={value}
        label={label}
        MenuProps={withMenuProps ? MenuProps : undefined}
        onChange={handleChange}
        sx={{ borderRadius: 3 }}
        disabled={disabled}
      >
        {withEmptyMenu && <MenuItem key="empty" value=""></MenuItem>}
        {items.map((item, index) => (
          <MenuItem
            value={valueProps ? item.value : item.id}
            key={`${index}-${item.id}`}
            disabled={item.disabled}
          >
            {item.value}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default Pulldown;
